export default __webpack_public_path__ + "static/myDocs-1f8740a74da351807c520fbb1122843e.jpg";